import axios from "axios";
// List products with Api
export async function SingleControl(offset, limit, path, path_type="", path_id="", user){
   
    const paths_type = (path_type)?'&'+path_type+'='+path_id : '';
    let jwt = user.token;
    const url = process.env.REACT_APP_ADMIN_API_URL + "/"+ path + "?offset="+offset+"&limit="+limit+paths_type+"&user_id="+user.id;
    try {
        const res = await axios.get(
            url,
            {
                "headers": {
                    "Authorization": "Bearer " + jwt
                }
            }
        );
        return res.data.data;
    } catch (err) {
        sessionStorage.removeItem('userSelect');
        throw err;
    }
};